<template>
  <div class="cq-logo">
    <router-link to="/"><b-img :src="logo" fluid alt="Logo"></b-img></router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {
      logo: require('@/assets/image/common/logo.png')
    }
  }
}
</script>

<style>

</style>